import React from 'react';
import { useDispatch } from 'react-redux';
import { resetState } from '.';

export default function useResetState() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(resetState(payload)), [dispatch]);
}
